
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/conta-pj",
      function () {
        return require("private-next-pages/conta-pj/index.js");
      }
    ]);
  